import React, { useState } from 'react';

export default function BetaCTA() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = !!email && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
    if (!isValid) {
      setStatus('error');
      setMessage('Please enter a valid email address.');
      return;
    }
    try {
      setStatus('loading');
      setMessage('');
      const isDev = process.env.NODE_ENV === 'development';
      const apiBase = isDev ? 'http://127.0.0.1:5001/moro-a4c90/us-central1' : '';
      const url = isDev ? `${apiBase}/sendWaitlist` : '/api/send-waitlist';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      if (!res.ok) throw new Error('Request failed');
      setStatus('success');
      setMessage('Thanks! Please check your email for confirmation.');
      setEmail('');
    } catch (err) {
      setStatus('error');
      setMessage('We couldn’t send your confirmation right now. Please try again later.');
    }
  };
  return (
    <section className="beta" id="cta">
      <div className="container">
        <div className="beta-grid">
          {/* Simple card */}
          <div className="cta-card cta-simple">
            <h2 className="cta-title">Join the Waitlist!</h2>
            <p className="cta-sub">Be the first to try Moro. Get notified at launch.</p>
            <form className="cta-form" onSubmit={handleSubmit} aria-live="polite">
              <input
                className="input light"
                type="email"
                placeholder="Email Address"
                aria-label="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={status === 'loading'}
              />
              <button className="btn btn-pill btn-gradient" type="submit" disabled={status === 'loading'}>
                {status === 'loading' ? 'Sending…' : 'Sign Up'}
              </button>
            </form>
            {message && (
              <p className="cta-foot" role="status" style={{ marginTop: 8 }}>
                {message}
              </p>
            )}
            <p className="cta-foot">We'll never spam you or sell your data.</p>
          </div>
        </div>
      </div>
    </section>
  );
}